// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-information {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-inline: auto;
}
.user-information .go-back {
  cursor: pointer;
  display: flex;
  gap: 4px;
  width: fit-content;
}
.user-information .information-container {
  background-color: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
}
.user-information .information-container .title-container {
  border-bottom: 1px solid #eaeaea;
  padding: 16px 16px 8px;
  width: 100%;
}
.user-information .information-container .title-container > h4 {
  margin-block: 0;
}
.user-information .information-container .content-container {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 16px;
}
.user-information .information-container .content-container .user-content-container {
  display: flex;
  gap: 10px;
  justify-content: center;
}
.user-information .information-container .content-container .user-content-container .account-section {
  flex: 1;
}
.user-information .information-container .content-container .user-content-container .account-actions-section {
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 22px;
  justify-content: flex-end;
}
.user-information .information-container .content-container .user-content-container .account-actions-section .cec-button {
  width: 50%;
}
.user-information .information-container .content-container .user-content-container .edit-icon {
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Dashboards/SupportDashboard/UserInformation/UserInformation.less"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;AADD;AAHA;EAOE,eAAA;EACA,aAAA;EACA,QAAA;EACA,kBAAA;AADF;AATA;EAcE,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;AAFF;AAfA;EAoBG,gCAAA;EACA,sBAAA;EACA,WAAA;AAFH;AApBA;EAyBI,eAAA;AAFJ;AAvBA;EA8BG,aAAA;EACA,sBAAA;EACA,SAAA;EACA,aAAA;AAJH;AA7BA;EAoCI,aAAA;EACA,SAAA;EACA,uBAAA;AAJJ;AAlCA;EAyCK,OAAA;AAJL;AArCA;EA6CK,mBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;AALL;AA7CA;EAqDM,UAAA;AALN;AAhDA;EA0DK,eAAA;AAPL","sourcesContent":["@import (reference) \"../../../../Styles/colors\";\n\n.user-information {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 16px;\n\tmargin-inline: auto;\n\n\t.go-back {\n\t\tcursor: pointer;\n\t\tdisplay: flex;\n\t\tgap: 4px;\n\t\twidth: fit-content;\n\t}\n\n\t.information-container {\n\t\tbackground-color: white;\n\t\tborder-radius: 8px;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\t.title-container {\n\t\t\tborder-bottom: 1px solid @light-gray-1;\n\t\t\tpadding: 16px 16px 8px;\n\t\t\twidth: 100%;\n\n\t\t\t> h4 {\n\t\t\t\tmargin-block: 0;\n\t\t\t}\n\t\t}\n\n\t\t.content-container {\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tgap: 24px;\n\t\t\tpadding: 16px;\n\n\t\t\t.user-content-container {\n\t\t\t\tdisplay: flex;\n\t\t\t\tgap: 10px;\n\t\t\t\tjustify-content: center;\n\n\t\t\t\t.account-section {\n\t\t\t\t\tflex: 1;\n\t\t\t\t}\n\n\t\t\t\t.account-actions-section {\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex: 1;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tgap: 22px;\n\t\t\t\t\tjustify-content: flex-end;\n\n\t\t\t\t\t.cec-button {\n\t\t\t\t\t\twidth: 50%;\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t\t.edit-icon {\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
